export default "__VITE_ASSET__DrTeOE4A__"